import { Box, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSkeleton = styled((props) => (
  <Skeleton {...props} variant="rectangular" />
))(() => ({
  borderRadius: '1rem',
  height: '4rem',
}));

export const ButtonsSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      alignItems: 'center',
    }}
  >
    <Skeleton width="15rem" height="3rem" variant="rounded" />
    <Skeleton width="25rem" height="3rem" variant="rounded" />
    {Array.from({ length: 4 }).map((v, i) => (
      <StyledSkeleton key={i} width="100%" />
    ))}
    <hr style={{ width: '100%' }} />
    {Array.from({ length: 2 }).map((v, i) => (
      <StyledSkeleton key={i} width="100%" />
    ))}
  </Box>
);

export const VideoSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    }}
  >
    <Skeleton width="15rem" />
    <Box sx={{ aspectRatio: '16 / 9' }}>
      <Skeleton variant="rectangular" width="100%" height="100%" />
    </Box>
  </Box>
);
